import type { CustomFieldDef, GlobalSetting } from '~/types/blog'

export async function useSiteData() {
  const blogApi = useBlogApi()
  const state = useState<{
    setting: GlobalSetting
    globalFields: CustomFieldDef[]
  } | null>('site-data', () => null)

  if (!state.value) {
    const [setting, globalFields] = await Promise.all([
      blogApi.getGlobalSetting(),
      blogApi.getFieldDefList('global')
    ])
    state.value = { setting, globalFields }
  }

  return state.value
}
